// src/admin/components/ErrorBoundary.tsx
import { Component, type ReactNode } from 'react';
import { Sentry } from '@admin/lib/sentry';

interface State { err: Error | null }
export default class ErrorBoundary extends Component<{ children: ReactNode; fallback?: ReactNode }, State> {
  override state: State = { err: null };
  static getDerivedStateFromError(err: Error): State { return { err }; }
  override componentDidCatch(error: Error, info: { componentStack: string | null }) {
    Sentry.captureException(error, { extra: { componentStack: info.componentStack } });
  }
  override render() {
    if (this.state.err) {
      return this.props.fallback ?? (
        <div style={{ padding: 32 }}>
          <h2>Something broke.</h2>
          <p className="small">{this.state.err.message}</p>
          <button onClick={() => this.setState({ err: null })}>Try again</button>
        </div>
      );
    }
    return this.props.children;
  }
}
